const convertNumber = (value) => {
  const formattedNumber = new Intl.NumberFormat({ style: "currency" }).format(
    value
  );
  return formattedNumber;
};

export default convertNumber;
